export const FORGOT_USERNAME = 'FORGOT_USERNAME';



// WEBPACK FOOTER //
// ./src/actions/username/types.js